import React, { Component } from "react";
import AppModalBs from "../../../partials/AppModalBs";

export default class IncompleteAssessmentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      cooldownSeconds: 0,
    };
    this.isProcessing = false;
    this.timer = null;
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.isProcessing = false;
  }

  handleConfirm = () => {
    if (this.isProcessing || this.state.isSubmitting || this.state.cooldownSeconds > 0) {
      return;
    }

    this.isProcessing = true;
    this.setState({ isSubmitting: true, cooldownSeconds: 10 }, () => {
      this.timer = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.cooldownSeconds <= 1) {
            clearInterval(this.timer);
            this.timer = null;
            this.isProcessing = false;
            return {
              cooldownSeconds: 0,
              isSubmitting: false,
            };
          }
          return {
            cooldownSeconds: prevState.cooldownSeconds - 1,
          };
        });
      }, 1000);
    });

    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
  };

  render() {
    let { id = "incompleteAssessmentModal", termLabel = "Mid-Year" } = this.props;
    let { cooldownSeconds } = this.state;
    const formattedTerm = termLabel || "Mid-Year";
    const isDisabled = this.isProcessing || this.state.isSubmitting || cooldownSeconds > 0;

    let buttonLabel = "Yes, Generate Report";
    if (cooldownSeconds > 0) {
      buttonLabel = `Please wait (${cooldownSeconds}s)`;
    } else if (isDisabled) {
      buttonLabel = "Generating...";
    }

    return (
      <AppModalBs id={id} hideHeader={true} contentClass="border-0 rounded-4 shadow p-4 text-center" size="modal-md">
        <div className="position-relative">
          <button
            type="button"
            className="btn-close position-absolute top-0 end-0 shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
            style={{ right: '0px', top: '0px', cursor: 'pointer' }}
          ></button>

          {/* Warning Icon Badge */}
          <div
            className="mx-auto mb-3 mt-2 d-flex align-items-center justify-content-center"
            style={{
              width: '68px',
              height: '68px',
              backgroundColor: '#fff3e0',
              borderRadius: '50%',
              color: '#e65100',
            }}
          >
            <i className="fa fa-exclamation-triangle" style={{ fontSize: '28px' }}></i>
          </div>

          {/* Modal Heading */}
          <h4 className="fw-bold text-dark mb-3" style={{ fontSize: '20px', letterSpacing: '-0.2px' }}>
            Incomplete {formattedTerm} Assessment Data
          </h4>

          {/* Content Description */}
          <div className="text-secondary mx-auto mb-4 px-2" style={{ fontSize: '14.5px', lineHeight: '1.6', maxWidth: '420px' }}>
            <p className="mb-2 text-dark">
              Some students do not have all their <strong>{formattedTerm}</strong> assessment scores filled in.
            </p>
            <p className="mb-3 text-muted" style={{ fontSize: '13.5px' }}>
              Generating the report now may result in <strong>incomplete student reports</strong> and inaccurate class-level comparisons.
            </p>
            <p className="fw-semibold text-dark mb-0 mt-3" style={{ fontSize: '15px' }}>
              Are you sure you want to generate the {formattedTerm} reports with the available data?
            </p>
          </div>

          {/* Action Buttons */}
          <div className="d-flex justify-content-center gap-3 mt-5 mb-2 pt-2">
            <button
              type="button"
              className="btn fw-semibold px-4 py-2"
              data-bs-dismiss="modal"
              style={{
                backgroundColor: '#f1f3f5',
                color: '#495057',
                borderRadius: '8px',
                border: 'none',
                minWidth: '110px',
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn text-white fw-bold px-4 py-2 shadow-sm"
              data-bs-dismiss={isDisabled ? undefined : "modal"}
              disabled={isDisabled}
              onClick={this.handleConfirm}
              style={{
                backgroundColor: isDisabled ? '#ccc' : '#ff9800',
                borderColor: isDisabled ? '#ccc' : '#ff9800',
                borderRadius: '8px',
                minWidth: '170px',
                cursor: isDisabled ? 'not-allowed' : 'pointer',
              }}
            >
              {buttonLabel}
            </button>
          </div>
        </div>
      </AppModalBs>
    );
  }
}
